import { COLOR_FAILURE, COLOR_WARNING, COLOR_SUCCESS, COLOR_INACTIVE } from '../../app-constants';
import { ExtractedDataOutput, JobCrossMatch } from '../../types/proccesingJobs';

class ColorPickerService {
  public getBorderColor = (crossMatches: JobCrossMatch[]) => {
    if (crossMatches.findIndex((match) => match.matchType === 2) >= 0) {
      return COLOR_FAILURE;
    }

    if (crossMatches.findIndex((match) => match.matchType === 1) >= 0) {
      return COLOR_WARNING;
    }

    if (crossMatches.findIndex((match) => match.matchType === 0) >= 0) {
      return COLOR_SUCCESS;
    }

    return COLOR_INACTIVE;
  };

  public getSingleBorderColor = (
    extractedDataOutput: ExtractedDataOutput,
    crossMatches: JobCrossMatch[],
  ) => {
    if (!extractedDataOutput.type || typeof extractedDataOutput.type !== 'string') {
      return COLOR_INACTIVE;
    }

    const expectedType = extractedDataOutput.type.replace(/ /g, '').toUpperCase();
    const filteredCrossMatches = crossMatches.filter(
      (match) => match.dataType.replace(/ /g, '').toUpperCase() === expectedType,
    );
    return this.getBorderColor(filteredCrossMatches);
  };
}

export default new ColorPickerService();
